import { shortsVideoApi, shortsVideoApiMultipart } from "./index";

export const getAllShorts = async (credentials) => {
    try {
      const response = await shortsVideoApi.post("/ShortsVideos/get-all-shorts", credentials);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

export const likeDislikeShorts = async (credentials) => {
  try {
    const response = await shortsVideoApi.post("/Like/LikeDislike", credentials);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getComments = async (videoId) => {
  try {
    const response = await shortsVideoApi.get(`/Comment/Get-comment-video/${videoId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const addComment = async (credentials) => {
  try {
    const response = await shortsVideoApi.post("/Comment/add-comment-shortsvideo", credentials);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const deleteComment = async (credentials) => {
  try {
    const response = await shortsVideoApi.delete("/Comment/delete-comment", {
      data: credentials
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getVideoById = async (userId, videoId) => {
  try {
    const response = await shortsVideoApi.get(`/ShortsVideos/get-video-by-id?UserId=${userId}&VideoId=${videoId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const uploadShorts = async (credentials) => {
  try {
    const response = await shortsVideoApiMultipart.post("/ShortsVideos/upload", credentials);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const deleteShortsVideo = async (credentials, token) => {
  try {
    console.log("credentials:", credentials);
    const response = await shortsVideoApi.delete(`/ShortsVideos/delete-video-by-id?videoId=${credentials.videoId}`, {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export const getFeaturedShorts = async (limit = 4) => {
  try {
    const response = await shortsVideoApi.get(`/ShortsVideos/get-featured-shorts?limit=${limit}`);
    return response.data;
  } catch (error) {
    console.warn("Failed to fetch featured shorts:", error);
    throw error;
  }
}

